import React, { useRef } from "react";
import { useInView } from "../hooks/useInView";
import { aboutContent, images } from "../data/mock";

export const AboutSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { threshold: 0.1 });

  return (
    <section
      id="about"
      ref={sectionRef}
      className="section-padding bg-warm-white relative"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div
            className={`relative ${
              isInView ? "animate-slide-in-left" : "opacity-0"
            }`}
          >
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={images.about}
                alt="Lobben Event Co. DJ Setup"
                className="w-full h-[500px] object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 border-2 border-gold/20 rounded-2xl -z-10" />
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-gold/10 rounded-2xl -z-10" />
          </div>

          {/* Content Side */}
          <div
            className={`${
              isInView ? "animate-slide-in-right" : "opacity-0"
            }`}
          >
            <span className="text-gold text-sm font-semibold tracking-widest uppercase mb-4 block">
              About Us
            </span>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-charcoal mb-8">
              {aboutContent.title}
            </h2>

            <div className="space-y-4">
              {aboutContent.paragraphs.map((paragraph, index) => (
                <p key={index} className="text-charcoal/60 leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-12 pt-8 border-t border-border">
              {aboutContent.stats.map((stat, index) => (
                <div key={index}>
                  <div className="font-display text-2xl font-bold text-gold">
                    {stat.number}
                  </div>
                  <div className="text-xs text-charcoal/50 mt-1 tracking-wide">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
